import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderPopoverService {
  private activePopover = new Subject<string>();
  activePopover$ = this.activePopover.asObservable();

  open(name: string): void {
    this.activePopover.next(name);
  }
}
